<template>
    <div class="" :class="{hidden: !loading}">
        <loading></loading>
    </div>

    <div class="max-w-md" :class="{ hidden: loading}">
        <form action="" class="form form--floating-label" @submit.prevent="formSubmit" ref='form' >
            <div class="style-emph mb-4">
                User Details
            </div>

            <div class="mb-5">
                <div class="input-container input-container--floating relative h-12 ">
                    <input
                            type="text"
                            v-model="selectedClient.account_number" disabled
                            class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue-gray "
                    />
                    <label class="absolute left-2 transition-all px-1 text-blue-gray">
                        Account Number
                    </label>
                </div>
            </div>

            <div class="mb-8">
                <div class="input-container input-container--floating relative h-12 ">
                    <input
                            type="text"
                            v-model="selectedClient.name" disabled
                            class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue-gray "
                    />
                    <label class="absolute left-2 transition-all px-1 text-blue-gray">
                        Client
                    </label>
                </div>
            </div>


            <div class="mb-5">
                <div class="input-container input-container--floating relative h-12 " :class="{empty: !formData.site_id, error: submittedOnce && errors.site_id}">
                    <input
                            id="site_id"
                            type="number"
                            v-model="formData.site_id"
                            class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
                            :disabled="!canEdit || !profile.isSharpAdmin()"
                    />
                    <label for="site_id" class="absolute left-2 transition-all px-1 text-blue-gray">
                        Site ID
                    </label>
                </div>

                <div v-if="submittedOnce && errors.site_id " class="text-red text-sm mt-2 leading-none">
                    {{ errors.site_id }}
                </div>
            </div>

            <div class="mb-5">
                <div class="input-container input-container--floating relative h-12 " :class="{empty: !formData.email, error: submittedOnce && errors.email}">
                    <input
                            id="email"
                            type="email"
                            v-model="formData.email"
                            class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
                            :disabled="!canEdit"
                    />
                    <label for="email" class="absolute left-2 transition-all px-1 text-blue-gray">
                        Email
                    </label>
                </div>

                <div v-if="submittedOnce && errors.email " class="text-red text-sm mt-2 leading-none">
                    {{ errors.email }}
                </div>
            </div>


            <div class="mb-5">
                <div class="input-container input-container--floating relative h-12 " :class="{empty: !formData.first_name, error: submittedOnce && errors.first_name}">
                    <input
                            id="first_name"
                            type="text"
                            v-model="formData.first_name"
                            class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue "
                            :disabled="!canEdit"
                    />
                    <label for="first_name" class="absolute left-2 transition-all px-1 text-blue-gray">
                        First Name
                    </label>
                </div>

                <div v-if="submittedOnce && errors.first_name " class="text-red text-sm mt-2 leading-none">
                    {{ errors.first_name }}
                </div>
            </div>


            <div class="mb-5">
                <div class="input-container input-container--floating relative h-12 " :class="{empty: !formData.last_name, error: submittedOnce && errors.last_name}">
                    <input
                            id="last_name"
                            type="text"
                            v-model="formData.last_name"
                            class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue "
                            :disabled="!canEdit"
                    />
                    <label for="last_name" class="absolute left-2 transition-all px-1 text-blue-gray">
                        Last Name (optional)
                    </label>
                </div>

                <div v-if="submittedOnce && errors.last_name " class="text-red text-sm mt-2 leading-none">
                    {{ errors.last_name }}
                </div>
            </div>


            <div class="mb-5">
                <div class="input-container input-container--floating relative h-12 " :class="{empty: !formData.phone , error: submittedOnce && errors.phone}">
                    <input
                            id="phone"
                            type="text"
                            v-model="formData.phone"
                            class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
                            :disabled="!canEdit"
                    />
                    <label for="phone" class="absolute left-2 transition-all px-1 text-blue-gray">
                        Phone (optional)
                    </label>
                </div>

                <div v-if="submittedOnce && errors.phone " class="text-red text-sm mt-2 leading-none">
                    {{ errors.phone }}
                </div>
            </div>

            <div class="mb-5" v-if="canEdit">
                <div class="input-container input-container--floating relative h-12 " :class="{empty: !formData.role , error: submittedOnce && errors.role}">
                    <select id="role"
                            v-model="formData.role"
                            class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue">
                        <option value=""></option>
                        <option value="group-admin" v-if="profile.isSharpAdmin() || profile.isGroupAdmin()">Group Admin</option>
                        <option value="manager">Account Admin</option>
                        <option value="user">Standard User</option>
                    </select>
                    <label for="role" class="absolute left-2 transition-all px-1 text-blue-gray">
                        Role
                    </label>
                </div>

                <div v-if="submittedOnce && errors.role " class="text-red text-sm mt-2 leading-none">
                    {{ errors.role }}
                </div>
            </div>



            <div v-if="success" class="bg-blue-success text-white mb-5 px-3 py-2 rounded ">
                {{ success }}
            </div>

            <div v-if="submittedOnce && errors.message" class="bg-red text-white mt-10 mb-5 px-3 py-2 rounded ">
                {{ errors.message }}
            </div>

            <div class="mt-10 flex flex-col md:flex-row items-center ">
                <button type="submit" class="btn w-full md:w-auto md:mr-8" v-if="canEdit">Save User Details</button>
                <a
                        @click="$router.go(-1)"
                        class="mt-3 md:mt-0 text-red hover:text-red-hover font-light underline cursor-pointer">Go Back</a>
            </div>
        </form>
    </div>
</template>

<script charset="utf-8">

import { values, join, get, assign, pick } from 'lodash';
import Loading from '../includes/Loading.vue';
import Vuex from 'vuex';

export default {
    props: ['userID', 'clientID'],
    data() {
        return {
            formData: {
                site_id: '',
                first_name: '',
                last_name: '',
                phone: '',
                email: '',
                role: ''
            },
            user: null,
            loading: false,
            submittedOnce: false,
            success: '',
            errors: {
                first_name: 'This field is required',
                email: 'This field is required',
                role: 'This field is required',
                phone: '',
            }
        }
    },

    emits: ["submit-success"],

    created() {
        this.loading = true;
        this.getUser({userID: this.userID})
            .then(user => {
                this.user = user;
                this.loading = false;
                this.formData = assign({}, this.formData, pick(user, [
                    'first_name', 'last_name', 'email', 'phone', 'role', 'site_id'
                ]));
            });
        this.getClient({clientID: this.clientID});
    },

    watch: {
        formData: {
            handler(newVal){
                this.errors.message = '';
                this.errors.first_name = newVal.first_name ? '' : 'This field is required';
                this.errors.email   = newVal.email  ? '' : 'This field is required';
                this.errors.role   = newVal.role  ? '' : 'This field is required';
                this.errors.phone   =  (!newVal.phone || newVal.phone.length >= 7) ? '' : 'Phone need to have at least 7 numbers';
            },
            deep: true
        }
    },

    computed: {
        ...Vuex.mapGetters('profile', {
            profile: 'profile'
        }),
        ...Vuex.mapGetters('accounts', {
            selectedUser: 'selectedUser',
            selectedClient: 'selectedClient',
        }),

        canEdit(){
            if(!this.profile.isSharpAdmin() && !this.profile.isGroupAdmin()){
                if(this.user?.role == 'group-admin' || this.user?.role == 'admin' || this.user?.role == 'super-admin'){
                    return false;
                }
            }
            if(this.profile.isGroupAdmin() && this.user?.role == 'group-admin'){
                return false;
            }
            if(this.profile.isManager() && this.user?.role == 'manager'){
                return false;
            }
            return true;
        }
    },

    components: {
        Loading
    },

    methods: {
        ...Vuex.mapActions('accounts', {
            getUser: 'getUser',
            getClient: 'getClient',
            updateUser: 'updateUser',
        }),

        formSubmit() {
            this.submittedOnce = true;
            this.errors.message = '';

            // do not submit if form has errors
            if (join(values(this.errors), '')) {
                return;
            }

            let data = {
                first_name: this.formData.first_name,
                last_name: this.formData.last_name,
                phone: this.formData.phone,
                email: this.formData.email,
                role: this.formData.role,
                client_id: this.clientID
            };

            if(this.profile.isSharpAdmin()){
                data['site_id'] = this.formData.site_id;
            }

            if(this.userID){
                data.id = this.userID;
            }

            this.loading = true;
            this.updateUser(data).then(res => {
                this.loading = false;
                this.success = 'User information has been saved successfully';
                this.$emit('submit-success');
            })
            .catch(err => {
                this.loading = false;
                this.errors = {
                    username: get(err, 'response.data.errors.username[0]'),
                    email: get(err, 'response.data.errors.email[0]'),
                    message: 'Invalid data'
                }
            })

        },
    }
}
</script>
